import { api, sendTimeout } from '../http';

export const fetchJudgmentDiligences = (auctionId, { activeOnly } = {}) => {
  const params = activeOnly ? '?active_only=true' : '';
  return api.get(`/auctions/${auctionId}/judgment-diligences${params}`);
};

export const fetchUnresolvedJudgmentDiligences = auctionId =>
  api.get(`/auctions/${auctionId}/judgment-diligences/unresolved`);

export const fetchJudgmentDiligenceById = (auctionId, diligenceId) =>
  api.get(`/auctions/${auctionId}/judgment-diligences/${diligenceId}`);

export const requestJudgmentDiligence = (auctionId, { itemIds, description }) =>
  api.post(`/auctions/${auctionId}/judgment-diligences`, { itemIds, description });

export const uploadJudgmentDiligenceDocuments = (
  auctionId,
  diligenceId,
  data,
  { onUploadProgress } = {},
) =>
  api.post(`/auctions/${auctionId}/judgment-diligences/${diligenceId}/documents`, data, {
    onUploadProgress,
    timeout: sendTimeout,
  });
